import React from "react"
import ScriptTag from "react-script-tag"

// Parameterized Airbnb listing embed. Replaces the former per-property
// shipwreckAirB / haidaAirB components. `path` is consumed by @reach/router
// when this is used as a routed child; it is ignored here.
const AirbnbEmbed = ({ roomId, shareId, label, width = "450px" }) => {
  const url = `https://www.airbnb.ca/rooms/${roomId}?s=66&unique_share_id=${shareId}&source=embed_widget`

  return (
    <div
      className="airbnb-embed-frame"
      data-id={roomId}
      data-view="home"
      style={{
        width,
        height: "300px",
      }}
    >
      <a href={url}>View On Airbnb</a>
      <a href={url} rel="nofollow">
        {label}
      </a>
      <ScriptTag
        isHydrating={false}
        type="text/javascript"
        src="https://www.airbnb.ca/embeddable/airbnb_jssdk"
      />
    </div>
  )
}

export default AirbnbEmbed
